import { useEffect, useState } from 'react';
import axios from 'axios';
import { Scales, TrendUp, TrendDown, Minus } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;

function avg(arr) {
  if (!arr.length) return null;
  const sum = arr.reduce((a, b) => a + b, 0);
  return sum / arr.length;
}

export default function WeightWeeklyAverageCard() {
  const [data, setData] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const { data: records } = await axios.get(`${API}/api/weight-records`);
        const sorted = [...(records || [])].filter(r => typeof r.peso === 'number' && r.date).sort((a, b) => a.date.localeCompare(b.date));
        if (sorted.length === 0) { setData({ empty: true }); return; }
        const today = new Date();
        const oneWeekAgo = new Date(today); oneWeekAgo.setDate(today.getDate() - 6);
        const twoWeeksAgo = new Date(today); twoWeeksAgo.setDate(today.getDate() - 13);
        const inRange = (d, from, to) => { const x = new Date(d); return x >= from && x <= to; };
        const thisWeek = sorted.filter(r => inRange(r.date, oneWeekAgo, today)).map(r => r.peso);
        const prevWeek = sorted.filter(r => inRange(r.date, twoWeeksAgo, new Date(oneWeekAgo.getTime() - 86400000))).map(r => r.peso);
        const cur = avg(thisWeek);
        const prev = avg(prevWeek);
        setData({ cur, prev, count: thisWeek.length, empty: cur === null });
      } catch { setData({ empty: true }); }
    })();
  }, []);

  if (!data || data.empty) return null;
  const diff = data.prev != null ? data.cur - data.prev : null;
  const arrow = diff == null ? Minus : (diff < -0.05 ? TrendDown : (diff > 0.05 ? TrendUp : Minus));
  const Arrow = arrow;
  const diffColor = diff == null ? '#7A8276' : (diff < -0.05 ? '#657161' : (diff > 0.05 ? '#C19A4D' : '#7A8276'));

  return (
    <div className="bg-white border border-brand-border rounded-2xl p-4" data-testid="weight-weekly-card">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-brand-green/10 flex items-center justify-center">
          <Scales size={20} className="text-brand-green" weight="duotone" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[10px] uppercase tracking-wider text-brand-muted">Média semanal do peso</p>
          <div className="flex items-baseline gap-2 mt-0.5">
            <span className="text-xl font-heading font-semibold text-brand-text">{data.cur.toFixed(1)} <span className="text-xs text-brand-muted font-normal">kg</span></span>
            {diff != null && (
              <span className="flex items-center gap-0.5 text-[11px] font-medium" style={{ color: diffColor }}>
                <Arrow size={12} weight="bold" />
                {diff > 0 ? '+' : ''}{diff.toFixed(1)} kg
              </span>
            )}
          </div>
          <p className="text-[10px] text-brand-muted mt-0.5">{data.count} {data.count === 1 ? 'registo' : 'registos'} nos últimos 7 dias{data.prev != null ? ' • vs semana anterior' : ''}</p>
        </div>
      </div>
    </div>
  );
}
